.b2{max-width:100%;}